// SPDX-License-Identifier: GPL-3.0-or-later

// Strip characters that break filenames on Windows/macOS/Linux, collapse
// whitespace, trim trailing dots, and cap length at 200 chars.
export function sanitizeFilename(name: string): string {
  // eslint-disable-next-line no-control-regex
  return name
    .replace(/[<>:"/\\|?*\x00-\x1f]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/\.+$/g, '')
    .trim()
    .substring(0, 200);
}

function monthFolder(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

async function dirExists(
  parent: FileSystemDirectoryHandle,
  name: string,
): Promise<boolean> {
  try {
    await parent.getDirectoryHandle(name);
    return true;
  } catch {
    return false;
  }
}

// Build "YYYY-MM CompanyName" relative to root, deduped with " 2", " 3" suffix.
export async function buildFolderRelPath(
  root: FileSystemDirectoryHandle,
  companyName: string,
  now: Date = new Date(),
): Promise<string> {
  const base = `${monthFolder(now)} ${sanitizeFilename(companyName) || 'Unknown'}`;
  let candidate = base;
  let counter = 1;
  while (await dirExists(root, candidate)) {
    counter++;
    candidate = `${base} ${counter}`;
  }
  return candidate;
}
